import styled, { css } from 'styled-components'

import { HeaderWrapper } from '../Comment'

export interface AnnotationListWrapperProps {
  $isModalVariant: boolean
  $isResolveAnnotationOn: boolean
}

export const AnnotationPopoverListWrapper = styled.div<AnnotationListWrapperProps>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  & [data-first-comment='true'] {
    & ${HeaderWrapper} {
      padding-right: ${({ $isResolveAnnotationOn }) =>
        $isResolveAnnotationOn ? '60px' : '48px'};

      ${({ $isModalVariant, $isResolveAnnotationOn }) =>
        $isModalVariant &&
        css`
          padding-right: ${$isResolveAnnotationOn ? '108px' : '96px'};
        `}
    }
  }
`
